import React from 'react'

import IneligibleError from '../../generic/IneligibleError'
import Error from '../../generic/Error'
import RadioToggle from '../../generic/toggles/radioToggle'

export default ({
  engines,
  engine,
  updateVehicleProp,
  isError,
  isDisabled,
  kbbUrl = 'https://www.kbb.com',
  isAdmin,
  isDigitalRetail,
  isCobrandDR,
  vin,
  year,
  make,
  model,
  trim,
  mileage,
  isIneligible,
  offerCode,
  isAssigned,
  isIneligibleVehiclesEnabled,
  isVehicleGrounded
}) => (
  <>
    <RadioToggle
      id={'engine'}
      pills={engines}
      testId={'vd-bt-engines'}
      isDisabled={isIneligible || isDisabled}
      selectedIndex={engine && engines.findIndex(a => a.displayName === engine.displayName)}
      onClickItem={index => updateVehicleProp('engine', engines[index].engineId)}
      isError={isError}
      stackedVertically={engines.length > 2}
      showIsDefault={true}
    />
    {!isIneligible && <Error isError={isError} id={'engine-error'} text={'Please select an engine.'} />}
    {engine && (
      <IneligibleError
        isError={engine.isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true)}
        detail="engine"
        kbbUrl={kbbUrl}
        isAdmin={isAdmin}
        isOfferCodeTcOffer={offerCode && offerCode.toUpperCase() === 'TC'}
        {...{ vin, year, make, model, trim, mileage, isDigitalRetail, isCobrandDR }}
      />
    )}
  </>
)
